export enum OrganizerTypes {
  GETALL = '@organizer/GETALL',
  GETALL_SUCCESS = '@organizer/GETALL_SUCCESS',
  GETALL_FAILED = '@organizer/GETALL_FAILED',
  CREATE = '@organizer/CREATE',
  CREATE_SUCCESS = '@organizer/CREATE_SUCCESS',
  CREATE_FAILED = '@organizer/CREATE_FAILED',
}
